import React from 'react';
import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { locationService } from '../services';
import type { SelectProps } from 'antd';
import { vietnameseToneInsensitiveIncludes } from '../utils/vietnameseText';

const { Option } = Select;

interface ProvinceSelectorProps extends Omit<SelectProps, 'options' | 'loading'> {
  value?: string;
  onChange?: (value: string) => void;
}

const ProvinceSelector: React.FC<ProvinceSelectorProps> = ({ value, onChange, ...restProps }) => {
  const { data: apiResponse, isLoading } = useQuery({
    queryKey: ['provinces'],
    queryFn: () => locationService.getProvinces(),
  });

  const provinces = apiResponse?.data || [];

  return (
    <Select
      value={value}
      onChange={onChange}
      loading={isLoading}
      placeholder="Chọn tỉnh/thành"
      showSearch
      filterOption={(input, option) =>
        vietnameseToneInsensitiveIncludes(String(option?.label ?? ''), input)
      }
      {...restProps}
    >
      {provinces.map((province) => (
        <Option
          key={province.province_code}
          value={province.province_code}
          label={province.name}
        >
          {province.name}
        </Option>
      ))}
    </Select>
  );
};

export default ProvinceSelector;

